// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1y8XR","container":"styles_container__qRC1G","title":"styles_title__1tMQ6","wrapper":"styles_wrapper__gPF7H","answer":"styles_answer__DMmlc"};